import { apiClient } from './client';
import type { LoginRequest, LoginResponse, ApiResponse, User } from '@shared/types';

export const authApi = {
  login: (data: LoginRequest) =>
    apiClient.post<ApiResponse<LoginResponse>>('/auth/login', data),

  logout: () =>
    apiClient.post<ApiResponse<void>>('/auth/logout'),

  me: () =>
    apiClient.get<ApiResponse<{ user: User }>>('/auth/me'),

  refresh: (refreshToken: string) =>
    apiClient.post<ApiResponse<{ token: string; refresh_token: string }>>('/auth/refresh', {
      refresh_token: refreshToken,
    }),
};

export const passwordChange = (payload: {
  current_password: string;
  new_password: string;
  confirm_password: string;
}) =>
  apiClient.post<ApiResponse<Record<string, unknown>>>('/auth/password-change', payload);

